<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-08-22 10:30:38
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
        <div class="pageTitle">通过排单设置需要调仓的仓库、商品和数量，调仓人员可按排单进行定仓、定品、定量扫码调仓，系统自动核对数据，未入库或已出货的商品不能调仓</div>
         <div class="btnBox">
            <el-button type="primary" @click="addDeliver()">添加调仓单</el-button>
      
        </div>
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="发货时间:" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form.start_time" style="width: 100%;"
                                    clearable></el-date-picker>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form.end_time" style="width: 100%;"
                                    clearable></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="调仓单号:">
                <el-input v-model="form.stock_in_sn" clearable></el-input>
            </el-form-item>
            <!--  -->
              <el-form-item label="调入仓库:" prop="region">
                <el-select v-model="form.warehouse_sn">
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                               :value="i.warehouse_sn"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="调出仓库:" prop="region">
                <el-select v-model="form.from_warehouse_sn">
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                               :value="i.warehouse_sn"></el-option>
                </el-select>
            </el-form-item>
           
               
            <el-form-item label="调仓状态:">
                <el-select v-model="form.allotment_status" clearable placeholder="请选择">
                    <el-option key='100' label="全部" value="100"></el-option>
                    <el-option key="0" label="待调仓" value="0"></el-option>
                    <el-option key="1" label="调仓中" value="1"></el-option>
                    <el-option key="2" label="调仓完成" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSearch()" class='mr-10'>搜索</el-button>
                <el-button @click="exportData()">导出</el-button>
            </el-form-item>
        </el-form>
        <!--表格-->
               <el-table
                        ref="multipleTable"
                        :data="tableData"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 95%;margin: 20px">
                    <el-table-column
                            prop="stock_in_sn"
                            label="调仓单号"
                            fixed>
                    </el-table-column>
                    <el-table-column
                            prop="from_warehouse_name"
                            label="调出仓库"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="warehouse_name"
                            label="调入仓库"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                 
               <el-table-column
                            prop=""
                            label="订单数量"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-button type='text' @click='detail(scope.row)'>{{scope.row.stock_in_num}}</el-button>
                            </template>
                    
                    </el-table-column>
                     <el-table-column
                            prop=""
                            label="已调仓数量"
                            show-overflow-tooltip>
                               <template slot-scope="scope">
                                <el-button type='text' @click='Waredetail(scope.row)'>{{scope.row.real_stock_in_num}}</el-button>
                            </template>
                    
                    </el-table-column>
                        <el-table-column
                            prop="allotment_name"
                            label="添加人"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                        <el-table-column
                            prop="created_at"
                            label="添加时间"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                        <el-table-column
                            prop="remarks"
                            label="备注"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                        <el-table-column
                            prop=""
                            label="调仓状态"
                            >
                    <template slot-scope="scope">
                        <span v-if='scope.row.allotment_status==0'>待调仓</span>
                        <span v-if='scope.row.allotment_status==1'>调仓中</span>
                        <span v-if='scope.row.allotment_status==2'>调仓完成</span>

                    </template>
                    </el-table-column>
                    <el-table-column
                            prop=""
                            label="操作"
                            
                           >
                        <template slot-scope="scope">
                <el-button type='text' @click='edit(scope.row.stock_in_sn)'>修改</el-button>
                <el-button type='text' @click="del(scope.row.stock_in_sn)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNo"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize">
                </el-pagination>
         
       
        <selectDealer
                v-if="selectDealerDialog"
                v-on:handleClose='selectDealerDialog = false'
                @pushData="getSelectinfo">
        </selectDealer>
        <!--批量导入-->
        <importData v-if="importDataDialog" v-on:handleClose='importDataDialog = false'
                    @refresh="onSearch">
        </importData>
        <!--物流码明细-->


             <el-dialog
  title="订单详情"
  :visible.sync="detailDialog"
  width="70%"
  >
    <!-- <el-button @click="exportDetail">导出明细</el-button> -->

    <el-table
              ref="multipleTable"
              :data="detailData.products"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
              
            >

              <el-table-column prop='production_batch' label="生产批次号" show-overflow-tooltip></el-table-column>
              <el-table-column prop='product_sn' label="商品编号" show-overflow-tooltip ></el-table-column>
              <el-table-column prop='product_name' label="商品名称" show-overflow-tooltip ></el-table-column>
              <el-table-column prop='product_specs' label="规格" show-overflow-tooltip ></el-table-column>          
              <el-table-column prop='stock_in_num' label="订单数量" show-overflow-tooltip ></el-table-column>
              <el-table-column prop='real_stock_in_num' label="已调仓数量" show-overflow-tooltip ></el-table-column>

            </el-table>
  <span slot="footer" class="dialog-footer">
    <el-button @click="detailDialog = false">取 消</el-button>
    <el-button type="primary" @click="detailDialog = false">确 定</el-button>
  </span>
</el-dialog>
<el-dialog
  title="调仓详情"
  :visible.sync="WaredetailDialog"
  width="70%"
  height='50%'
  >

      <div class="tableBox" v-loading="loading" style='width:100%;overflow: scroll;hieght:200px;'>
            <table class="table table-striped table-bordered table-hover">
                <thead>
                <tr>
                    <th style="width: 80px;">调仓单号</th>
                    <th style="width: 140px">调出仓库</th>
                    <th style="width: 120px">调入仓库</th>
                    <th style="width: 240px">物流码</th>
                    <th style="width: 220px">标签类型</th>
                    <th style="width: 120px">生产批次号</th>
                    <th style="width: 120px">商品编号</th>
                    <th style="width: 120px">商品名称</th>
                    <th style="width: 120px">规格</th>
                    <th style="width: 160px">调仓数量</th>
                    <th style="width: 160px">操作人</th>
               
                </tr>
                </thead>
                <tbody>
                    <!-- {{WaredetailData}} -->

                <template v-for="item  in WaredetailData"  >

                    <!-- <template v-for="(val,index) in item.products"> -->
                      
                        <tr>
                         
                            <!-- <template v-if="item.products.length > 0 && index > 0">
                                <td colspan="5"></td>
                            </template>
                            <template v-else> -->
                          

                                <td style="white-space: nowrap;">{{item.stock_in_sn}}</td>
                                <td style="white-space: nowrap;">{{item.from_warehouse_name}}</td>
                                <td style="white-space: nowrap;">{{item.warehouse_name}}</td>
                                <td style="white-space: nowrap;">{{item.logistics_code}}</td>
                                <td style="white-space: nowrap;">{{item.code_name}}</td>
                            <!-- </template> -->
                            <td style="white-space: nowrap;">{{item.production_batch}}</td>
                            <td style="white-space: nowrap;">{{item.product_sn}}</td>
                            <td style="white-space: nowrap;">{{item.product_name}}</td>
                            <td style="white-space: nowrap;">{{item.product_specs}}</td>
                            <td style="white-space: nowrap;">{{item.real_stock_in_num}}</td>
                            <td style="white-space: nowrap;">{{item.allotment_name}}</td>
                            <!-- <td style="white-space: nowrap;">{{val.product_unit}}</td> -->
                      
                        </tr>
                    <!-- </template> -->
                </template>

                </tbody>
            </table>
        </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="WaredetailDialog = false">取 消</el-button>
    <el-button type="primary" @click="WaredetailDialog = false">确 定</el-button>
  </span>
</el-dialog>
       
    </div>
</template>

<script>
    import selectDealer from '@/components/logistics/common/selectDealer.vue';
    export default {
        name: "deliver-manage",
        data() {
            return {
                detailDialog:false,
                WaredetailDialog:false,
                WaredetailData:{},
                loading:false,
                selectDealerDialog: false,
                importDataDialog: false,
                deliverCodeDialog: false,
                form: {
                    start_time: '',
                    end_time: '',
                    stock_in_sn: '',
                    stock_out_sn: '',
                    product_sn: '',
                    product_name: '',
                    warehouse_sn: '',
                    from_warehouse_sn:"",
                    status: '',
                    to_sn: '',
                    to_type: '',
                    isgift: ''
                },
                stockArray: [],//仓库
                tableData: [],
                //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                stock_out_sn: '',//传给物流明细
                showLink:false,//'登陆地址弹窗'
                detailData:{}
            }
        },
        methods:
            {
                getLastMonth() {
                    var now = new Date();
                    var year = now.getFullYear();//getYear()+1900=getFullYear()
                    var month = now.getMonth() + 1;//0-11表示1-12月
                    var day = now.getDate();
                    var dateObj = {};
                    if (parseInt(month) < 10) {
                        month = "0" + month;
                    }
                    if (parseInt(day) < 10) {
                        day = "0" + day;
                    }

                    dateObj.now = year + '-' + month + '-' + day;

                    if (parseInt(month) == 1) {//如果是1月份，则取上一年的12月份
                        dateObj.last = (parseInt(year) - 1) + '-12-' + day;
                        return dateObj;
                    }

                    var preSize = new Date(year, parseInt(month) - 1, 0).getDate();//上月总天数
                    if (preSize < parseInt(day)) {//上月总天数<本月日期，比如3月的30日，在2月中没有30
                        dateObj.last = year + '-' + month + '-01';
                        return dateObj;
                    }

                    if (parseInt(month) <= 10) {
                        dateObj.last = year + '-0' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    } else {
                        dateObj.last = year + '-' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    }

                },
                
              Waredetail(data){
                     
                    this.loading=true

                     var url='/allocations/'+data.stock_in_sn+'/datas'
                          this.$get('logistics',url).then(res=>{
                        this.WaredetailData=res.data
                    this.loading=false
                    this.WaredetailDialog=true
                    }).catch(error=>{
                    this.loading=false

                        this.$message({
                            type:'error',
                            message:error.message
                        })
                    })
                },
                detail(data){
                    this.loading=true
                    // var url='/allocations.products'
                      var url='/allocations/'+data.stock_in_sn
                    this.$get('logistics',url,{
                        warehouse_sn:data.from_warehouse_sn
                    }).then(res=>{
                        this.detailData=res.data
                    this.loading=false
                    this.detailDialog=true
                    }).catch(error=>{
                    this.loading=false

                        this.$message({
                            type:'error',
                            message:error.message
                        })
                    })
                },
                //获取仓库
                getStock() {
                    this.$get('logistics', '/warehouses.all', {
                        lang: ''
                    }).then(res => {
                        this.stockArray = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                //获取选择经销商门店
                getSelectinfo(val) {
                    if (val.dealer_sn) {
                        this.form.to_sn = val.dealer_sn;
                        this.form.to_type = 2;

                    } else {
                        this.form.to_sn = val.shop_sn;
                        this.form.to_type = 3;
                    }
                },
                //请求列表数据
                onSearch() {
                    let beginstr = '', endstr = '';
                    if (this.form.start_time) {
                        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
                    }
                    if (this.form.end_time) {
                        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
                    }
                    this.loading = true;
                    this.$get('logistics', '/allocations', {
                        lang: '',
                        start_time: beginstr,
                        end_time: endstr,
                      
                       
                        stock_in_sn: this.form.stock_in_sn,
                        warehouse_sn: this.form.warehouse_sn,
                        stock_in_sn: this.form.stock_in_sn,
                        from_warehouse_sn: this.form.from_warehouse_sn,
                        allotment_status: this.form.allotment_status,
                    
                        per_page: this.pageSize,
                        page: this.pageNo
                    }).then(res => {
                        this.loading = false;
                        this.tableData = res.data;
                        this.totalSize = res.meta.total;
                    }).catch(function (error) {
                        this.loading = false;
                        console.log(error);
                    });
                },
                //添加发货
                addDeliver() {
                    this.$router.push({
                        name: 'addWareOrder'
                    });
                },
                //批量导入
                importData() {
                    this.importDataDialog = true;
                },
                //选择经销商/门店
                selectType() {
                    this.selectDealerDialog = true;
                },
                //导出
                exportData() {
                    let beginstr = '', endstr = '';
                    if (this.form.start_time) {
                        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD")
                    }
                    if (this.form.end_time) {
                        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
                    }
                    let url = '',access_tokens = localStorage.getItem('access_tokens');
                  

                    window.open(this.$Base_Export+
                        + '/allocations.export?start_time=' + beginstr + '&is_export=1'+'&end_time=' + endstr + '&product_sn=' +
                        this.form.product_sn + '&stock_out_sn=' + this.form.stock_out_sn + '&stock_in_sn=' + this.form.stock_in_sn +
                        '&product_name=' + this.form.product_name + '&lang=' + '' +'&from_warehouse_sn='+ this.form.from_warehouse_sn+ '&warehouse_sn=' + this.form.warehouse_sn + '&status=' + this.form.status +'&signature='+ this.$md5(access_tokens)

                    )
                },
            
            
                //删除
                del(item) {
                    this.$confirm('是否删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let url = '/allocations/' + item;
                        this.$delete('logistics', url, {}).then(res => {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.onSearch();
                        }).catch(error =>{
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });

                    }).catch(error =>{
                        this.$message({
                            type: 'error',
                            message: error.message
                        });

                    });

                },
                // 修改
                edit(sn){
                    this.$router.push({
                        name:'addWareOrder',
                        query:{
                            edit:sn
                        }
                    })
                },
                /*分页*/
                handleSizeChange(val) {

                    this.pageSize = val;
                    this.pageNo = 1;
                    this.onSearch();
                },
                handleCurrentChange(val) {
                    this.pageNo = val;
                    this.onSearch();

                }
                ,
                // 关闭 登陆地址弹窗
                closeLink(){
                    this.showLink=!this.showLink
                }

            },
        created() {
            this.form.start_time = this.getLastMonth().last;
            this.form.end_time = this.getLastMonth().now;
            this.getStock();
            this.onSearch();

        },
        components: {
            // , importData, deliverCodeDialog
            selectDealer,
        }
    }
</script>
<style lang="scss" scoped>
.container{
    overflow-x:hidden;
}
    .tableBox {
        // overflow-x:hidden;
        padding-right: 5px;
       
        .table {
            width: 300%;
        }
    }
/deep/.el-button--text{
    padding: 0;
} 
</style>